import React from 'react'
import { Create, useForm } from '@refinedev/antd'
import { Form } from 'antd'
import type { Tables } from '@muaa/shared'
import { ReleaseFormFields } from './ReleaseFormFields'

type Release = Tables<'releases'>

export function ReleaseCreate() {
  const { formProps, saveButtonProps } = useForm<Release>()

  return (
    <Create saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          items: [],
          show_in_feed: false,
          published_at: null,
        }}
      >
        <ReleaseFormFields />
      </Form>
    </Create>
  )
}
